var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHotTub = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 8C8.10457 8 9 7.10457 9 6C9 4.89543 8.10457 4 7 4C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.15 12C10.84 11.78 10.56 11.54 10.33 11.28L8.93 9.73C8.74 9.52 8.5 9.35 8.24 9.23C7.95 9.09 7.62 9 7.28 9H7.25C6.01 9 5 10.01 5 11.25V12H2V22H22V12H11.15ZM7 20H5V14H7V20ZM11 20H9V14H11V20ZM15 20H13V14H15V20ZM19 20H17V14H19V20ZM18.65 5.86L18.58 5.79C18.01 5.17 17.76 4.38 17.91 3.59L18 3H16.11L16.05 3.43C15.85 4.79 16.32 6.14 17.35 7.15L17.42 7.21C17.99 7.83 18.24 8.62 18.09 9.41L17.98 10H19.89L19.95 9.57C20.16 8.21 19.68 6.86 18.65 5.86ZM14.65 5.86L14.58 5.79C14.01 5.17 13.76 4.38 13.91 3.59L14 3H12.11L12.05 3.43C11.85 4.79 12.32 6.14 13.35 7.15L13.42 7.21C13.99 7.83 14.24 8.62 14.09 9.41L13.98 10H15.89L15.95 9.57C16.16 8.21 15.68 6.86 14.65 5.86Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHotTub, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hot_tub.d9f6748e.svg";
export { ForwardRef as ReactComponent };